import { Cache } from "memory-cache";
import { CorporationContractEntity } from ".";
import { Client } from "../service/esiclient";
import { fetchCharacterTokenFromID } from "../helpers/tokenhelper";

const esiClient = new Client();
// Cache
const cache = new Cache();
export async function getCachedCorporationContractEntity(
  transaction_id: number
): Promise<CorporationContractEntity | null> {
  let entity: any = await cache.get(transaction_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationContractEntity(id: CorporationContractEntity) {
  cache.put(id.props.contract_id.toString(), id, 60 * 60 * 1000 /* 1 hour */);
}

export async function getCachedCorporationContractItems(
  contract_id: number,
  character_id: number,
  corporation_id: number
): Promise<any | null> {
  let entity: any = await cache.get("corpitems-" + contract_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const accesstoken = await fetchCharacterTokenFromID(character_id);
    if (accesstoken.success) {
      const contract_items = await esiClient.get_corporations_corporation_id_contracts_contract_id_items(
        contract_id,
        corporation_id,
        null,
        null,
        accesstoken.token
      );
      if (contract_items !== null) {
        entity = contract_items;
        cache.put("corpitems-" + contract_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
        return entity;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

export async function getCachedCorporationContractBids(
  contract_id: number,
  character_id: number,
  corporation_id: number
): Promise<any | null> {
  let entity: any = await cache.get("corpbids-" + contract_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const accesstoken = await fetchCharacterTokenFromID(character_id);
    if (accesstoken.success) {
      const bids = await esiClient.get_corporations_corporation_id_contracts_contract_id_bids(
        contract_id,
        corporation_id,
        null,
        null,
        null,
        accesstoken.token
      );
      if (bids !== null) {
        entity = bids;
        cache.put("corpbids-" + contract_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
        return entity;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}
